<template>
  <div v-sticky="{ zIndex: 1 }" class="wrapper">
    <div>
      <slot/>
    </div>
  </div>
</template>

<script>
import VueSticky from 'vue-sticky';
export default {
  directives: {
    'sticky': VueSticky,
  },
}
</script>

<style lang="scss">
.wrapper {
  height: 100vh;
  @media (max-width: 767px) {
    height: 70vh;
  }
  > div {
    height: 100%;
    position: relative;
  }
}
</style>



// WEBPACK FOOTER //
// Sticky.vue?5dcbbfe2